import React, { PureComponent } from 'react'

import { grant } from '../Utils/Service'

class CoursesDetails extends PureComponent {
  render () {
    const c = this.props.course
    return (
      <ul className={'row-item ' + c.color}>
        <li>
          <span>Nome</span>
          {c.name}
        </li>
        <li className="info-buttons">
          {
            grant() && (
              <button className="lnk-edits" onClick={() => this.props.showEdit(c)}><i className="fas fa-edit"></i></button>
            )
          }
          {
            grant() && (
              <button className="lnk-edits" onClick={() => this.props.showDelete(c)}><i className="fas fa-trash-alt"></i></button>
            )
          }
        </li>
      </ul>
    )
  }
}

export default CoursesDetails



// WEBPACK FOOTER //
// ./src/components/Courses/CoursesDetails.js